import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { friendsRoutes } from "routes";

import Store from "views/Store";
import Avatar from "components/Avatar";
import ServerChat from "components/ServerChat";
import StoreHeader from "components/header/StoreHeader";
import ServerHeader from "components/header/ServerHeader";
import FriendsHeader from "components/header/FriendsHeader";
import SidebarFriends from "components/SidebarFriends";
import FriendsChatHeader from "components/header/FriendsChatHeader";
import SidebarServerChannels from "components/SidebarServerChannels";

import Active from "views/friendsViews/Active";
import Chat from "views/Chat";

import "assets/css/dashboard.css";
import { useSelector } from "react-redux";
import VoiceConnectedPanel from "components/VoiceConnectedPanel";
import ServerMenu from "components/ServerMenu";

const Dashboard = ({ show2, setShow2 }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [server, setServer] = useState({});
  const [stream, setStream] = useState(false);
  const [friends, setFriends] = useState("online");
  const serverList = useSelector(state => state.server.items);

  useEffect(() => {
    const handleStreamStart = () => setStream(true);
    const handleStreamEnd = () => setStream(false);
    window.addEventListener("streamStart", handleStreamStart);
    window.addEventListener("streamEnd", handleStreamEnd);
    return () => {
      window.removeEventListener("streamStart", handleStreamStart);
      window.removeEventListener("streamEnd", handleStreamEnd);
    };
  }, []);

  useEffect(() => {
    if (serverList.length === 0) return;
    const server = serverList.find(
      server => server._id === location.pathname.split("/")[2]
    );
    if (!server) return;
    setServer(server);
  }, [serverList, location]);

  const changeFriends = e => {
    setFriends(e);
  };

  const changeHistory = e => {
    navigate(e);
    if (e === "/channels/@me") setFriends("online");
    else setFriends(null);
  };

  return (
    <>
      <div className={`dashboard-wrapper${show2 ? " show" : ""}`}>
        <div className="dashboard-second-wrapper">
          <div className="dashboard-sidebar">
            <div id="container">
              <nav className="dashboard-side-navbar">
                <div
                  className="dashboard-navbar-search-button-wrapper"
                  style={{ padding: 0 }}
                >
                  <Routes>
                    <Route
                      path="@me"
                      element={
                        <div className="dashboard-navbar-search-button-wrapper">
                          <button className="dashboard-navbar-search-button">
                            {"Sohbet bul ya da başlat"}
                          </button>
                        </div>
                      }
                    />
                    <Route
                      exact
                      strict
                      sensitive
                      path={"@me/:id"}
                      element={
                        <div className="dashboard-navbar-search-button-wrapper">
                          <button className="dashboard-navbar-search-button">
                            {"Sohbet bul ya da başlat"}
                          </button>
                        </div>
                      }
                    />
                    <Route
                      path={":serverID/:channelID"}
                      element={<ServerMenu server={server} />}
                    />
                    <Route
                      index
                      element={
                        <div className="dashboard-navbar-search-button-wrapper">
                          <button className="dashboard-navbar-search-button">
                            {"Sohbet bul ya da başlat"}
                          </button>
                        </div>
                      }
                    />
                  </Routes>
                </div>
                <Routes>
                  <Route
                    path="@me"
                    element={
                      <SidebarFriends
                        friends={friends}
                        changeFriends={changeFriends}
                        show2={show2}
                        setShow2={setShow2}
                      />
                    }
                  />
                  <Route
                    exact
                    strict
                    sensitive
                    path={"@me/:id"}
                    element={
                      <SidebarFriends show2={show2} setShow2={setShow2} />
                    }
                  />
                  <Route
                    path={":serverID/:channelID"}
                    element={
                      <SidebarServerChannels
                        show2={show2}
                        setShow2={setShow2}
                      />
                    }
                  />
                  <Route
                    index
                    element={
                      <SidebarFriends
                        servers={friends}
                        changeServers={changeFriends}
                        show2={show2}
                        setShow2={setShow2}
                      />
                    }
                  />
                </Routes>
              </nav>
              <VoiceConnectedPanel />
              <Avatar />
            </div>
          </div>
          <div className={`panel-mobile-wrapper${show2 ? " show" : ""}`}>
            <div className="dashboard-panel">
              <div
                className="dashboard-panel-header-wrapper"
                style={{ background: stream ? "rgba(0,0,0,0.8)" : "inherit" }}
              >
                <div
                  style={{ width: 50, height: 50 }}
                  className="dashboard-panel-sandwich-container"
                >
                  <div
                    className="dashboard-panel-sandwich-wrapper"
                    onClick={() => {
                      setShow2(prv => !prv);
                    }}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <Routes>
                  <Route
                    path="@me"
                    element={
                      <FriendsHeader
                        friends={friends}
                        changeFriends={changeFriends}
                      />
                    }
                  />
                  <Route
                    exact
                    strict
                    sensitive
                    path={"@me/:id"}
                    element={<FriendsChatHeader />}
                  />
                  <Route
                    path={":serverID/:channelID"}
                    element={<ServerHeader />}
                  />
                  <Route
                    index
                    element={
                      <StoreHeader
                        servers={friends}
                        changeServers={changeFriends}
                      />
                    }
                  />
                </Routes>
              </div>
              <div className="dashboard-panel-body-wrapper">
                <Routes>
                  <Route
                    path="@me"
                    element={
                      friends && (
                        <>
                          <div className="friends-wrapper">
                            <div className="friends-add-wrapper">
                              {friendsRoutes[friends]}
                            </div>
                            <Active />
                          </div>
                        </>
                      )
                    }
                  />

                  <Route path={"@me/:id"} element={<Chat />} />
                  <Route
                    path={":serverID/:channelID"}
                    element={<ServerChat />}
                  />
                  <Route index element={<Store />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(Dashboard);
